import { CancelTokenSource } from 'axios';
import { LocationDto, LocationSearchRequest, UpsertLocationDto } from 'ts-types/api.types';
import axios from 'services/http';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/locations`;

export const getAllLocations = (
    source: CancelTokenSource): Promise<Array<LocationDto>> => {

  return axios
      .get(`${apiUri}`, {cancelToken: source.token})
      .then((response) => response.data);
};

export const findLocationById = (
    id: number,
    source: CancelTokenSource): Promise<UpsertLocationDto> => {

  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const addLocation = (
    upsertLocationDto: Partial<UpsertLocationDto>,
    source: CancelTokenSource): Promise<LocationDto> => {

  return axios
      .post(`${apiUri}/add`, upsertLocationDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editLocation = (
    id: number,
    upsertLocationDto: Partial<UpsertLocationDto>,
    source: CancelTokenSource): Promise<LocationDto> => {

  return axios
      .put(`${apiUri}/edit/${id}`, upsertLocationDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteLocationById = (
    id: number,
    source: CancelTokenSource): Promise<LocationDto> => {

  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const searchLocations = (
    locationsSearchRequest: Partial<LocationSearchRequest>,
    source: CancelTokenSource): Promise<Array<LocationDto>> => {

  return axios
      .post(`${apiUri}/search`, locationsSearchRequest, {cancelToken: source.token})
      .then(response => response.data)
};
